// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../types';

import gql from 'graphql-tag';
export type GetStatusesEventFragment = { __typename?: 'Event', proposalCount: number, status: Types.EventStatus };

export const GetStatusesEventFragmentDoc = gql`
    fragment GetStatusesEvent on Event {
  proposalCount
  status
}
    `;